export default {
  model: {
    prop: 'visible',
    event: 'close',
  },
  props: {
    visible: Boolean,
  },

  methods: {
    onClose() {
      this.$emit('close', false)
    },
  },
}